import React from "react";
import type { GeneratedSlides, ColorScheme } from "../types";
import { getSlideColor } from "../utils";

interface SlideThumbnailsProps {
  generatedSlides: GeneratedSlides;
  selectedSlide: number;
  onSelectSlide: (index: number) => void;
  colorScheme: ColorScheme;
}

export const SlideThumbnails: React.FC<SlideThumbnailsProps> = ({
  generatedSlides,
  selectedSlide,
  onSelectSlide,
  colorScheme,
}) => {
  const primaryColor = getSlideColor(colorScheme);

  return (
    <div className="w-48">
      <div className="text-sm font-medium mb-3 text-(--text-secondary)">
        Slides ({generatedSlides?.slides?.length || 0})
      </div>
      <div className="space-y-2 max-h-96 overflow-y-auto pr-2">
        {generatedSlides?.slides?.map((slide, index) => (
          <button
            key={slide.id}
            onClick={() => onSelectSlide(index)}
            className={`w-full p-3 rounded-lg border text-left transition ${
              selectedSlide === index
                ? "border-blue-500 bg-blue-50 dark:bg-blue-900/20"
                : "border-(--border-color) hover:border-blue-500 bg-(--card-bg)"
            }`}
          >
            <div className="flex items-center gap-2 mb-1">
              <div
                className="w-6 h-6 rounded-full flex items-center justify-center text-xs font-medium"
                style={{
                  backgroundColor:
                    selectedSlide === index
                      ? primaryColor
                      : "var(--bg-secondary)",
                  color:
                    selectedSlide === index ? "white" : "var(--text-secondary)",
                }}
              >
                {slide.id}
              </div>
              <span
                className="text-xs font-medium"
                style={{
                  color:
                    selectedSlide === index
                      ? primaryColor
                      : "var(--text-primary)",
                }}
              >
                {slide.type === "title"
                  ? "Título"
                  : slide.type === "summary"
                    ? "Resumo"
                    : slide.type === "image"
                      ? "Imagem"
                      : "Conteúdo"}
              </span>
            </div>
            <p className="text-xs truncate text-(--text-tertiary)">
              {slide.title}
            </p>
          </button>
        ))}
      </div>
    </div>
  );
};
